import type { IOutrightResult, IOutrightTournamentResult } from '@/interface/IMatchResult';
import type { SportType } from '@/interface/enum';
import type { TournamentResponse } from '@/interface/pollux';
import { parseISOString } from '@/libraries/utils/date';

export function formatOutrightResults(sportType: SportType, tournaments: TournamentResponse[]): IOutrightTournamentResult[] {
    return tournaments.map(tournament => ({
        sportType,
        id: tournament.id,
        name: tournament.name ?? '',
        eventDate: parseISOString(tournament.eventDate),
        hasNoWinner: tournament.hasNoWinner,
        outrights: (tournament.outrights ?? []).map<IOutrightResult>(o => ({
            id: o.id,
            matchCode: o.matchCode ?? '',
            eventDate: parseISOString(tournament.eventDate),
            result: o.result,
            teamId: o.teamId,
            teamName: o.teamName ?? '',
        })),
    }));
}
